export const Config = {
  apiUrl: "/api/v1/",
  apiBaseUrl: "https://ajosquadbackend-staging.up.railway.app"
  // defaults: {
  //   paginator: {
  //     pageKey: "page",
  //     limitKey: "limit",
  //     searchKey: "search",
  //     limit: 10,
  //     startPage: 1,
  //   },
  // },
};
